module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bankStatementWrapper"
    }
  }, [(_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts,
      "groups": _vm.groups,
      "groupingOptions": _vm.groupingOptions
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('saldoBancario.titulos.saldoBancario'),
      "subTitle": _vm.$t('saldoBancario.titulos.visualize')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('saldoBancario.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 121,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('saldoBancario.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('saldoBancario.labels.selecionarContasBancarias'),
      "id": "btnSelecionarContasBancarias",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "SaldoConta",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "saldoBancario",
      "treeGridLayoutPath": "bankBalance",
      "showMassTaskAction": false,
      "showAlert": true,
      "alertMessage": _vm.$t('saldoBancario.labels.alertaGrid'),
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28cf8108", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cf8108"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/bankBalance/bankBalance.pug
// module id = 1383
// module chunks = 0